var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('main',{staticClass:"align-center"},[_c('v-container',{attrs:{"fluid":""}},[_c('nuxt')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }